module.exports = __webpack_public_path__ + "static/media/round2.af62915a.jpeg";